import { render, staticRenderFns } from "./instagram_campaign_analytics_dialog.vue?vue&type=template&id=af39629e&scoped=true"
import script from "./instagram_campaign_analytics_dialog.vue?vue&type=script&lang=ts"
export * from "./instagram_campaign_analytics_dialog.vue?vue&type=script&lang=ts"
import style0 from "./instagram_campaign_analytics_dialog.vue?vue&type=style&index=0&id=af39629e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af39629e",
  null
  
)

export default component.exports